module.exports = __webpack_public_path__ + "img/kenya.69f959d3.svg";